export default __webpack_public_path__ + "static/media/devide~bhankJaN.4cf95d94.svg";